import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar from '../EcoClub/Sidebar';
import EcoClub2026 from '../EcoClub2026';



const EcoClub2Class2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass2/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass2/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass2/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass2/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass2/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/club/EcoClub/ecoclubclass2/6.webp`;


  const photos = [
    {
        src: p1,
        source: p1,
        rows: 1,
        cols: 1,
    },
    {
        src: p2,
        source: p2,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
    },
    {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
    },
    {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
    }

  ];

  return (
    <Main>
   
<Container>

  <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center' >
     World Environment Day  
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
      Class: 2  &  Date:  29 June 2026
        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
"Nurture nature, and nature will nurture you."
        <br/>
        </Typography>
        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        As part of our ongoing efforts to nurture environmental awareness and a love for nature, the enthusiastic students of Class 2 participated in a joyful Plantation Drive by planting coriander seeds on 29 June 2026.
The activity began with an interactive discussion on the importance of plants in our daily lives. Students learned how plants provide us with fresh air, food and a healthy environment. They were introduced to 
the simple steps of gardening and understood how even tiny seeds can grow into useful plants with proper care and patience.
        <br></br>
        With great excitement, each child carefully sowed coriander seeds, covered them gently with soil and watered them. The young gardeners eagerly 
        observed every step, knowing that their little act of planting would soon blossom into fresh green leaves.
 <br></br>
 The plantation activity was much more than a gardening exercise. It encouraged curiosity, responsibility, and respect for nature. As the children pledged to water their plants regularly
  and watch them grow, they learned valuable lessons about patience, care, and the rewards of nurturing living things.
         <br></br>
The smiles on their faces reflected the joy of learning through hands-on experiences. The Plantation Drive beautifully reinforced the message that every small effort contributes to a greener, healthier planet. By planting coriander seeds today, 
our young learners took their first step towards becoming environmentally conscious and responsible citizens of tomorrow.
                  <br></br>
         The activity was a memorable and enriching experience that combined learning with fun, inspiring our little learners to cherish and protect the natural world around them.
         <br></br>

        </Typography>
      </Box>
      

      <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>

    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <EcoClub2026   />
             </Box>
             <Box marginBottom={4}>
               <Sidebar />
             </Box>


    </Grid>
    </Grid> 
    </Container>
    </Main>
   
   
  );
};

export default EcoClub2Class2026;